import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Hook to invalidate all division-related queries.
 * Use this after creating, updating, or deleting divisions.
 */
export const useInvalidateDivisions = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["useDivisionsQuery"]
    });
    await queryClient.invalidateQueries({
      queryKey: ["useDivisionsMenuQuery"]
    });
    await queryClient.invalidateQueries({
      queryKey: ["organizations.offices"]
    });
  }, [queryClient]);
};
